import { fork, all } from 'redux-saga/effects';
import siteComponentSagas from 'yoda-site-components/lib/sagas';
import watchPlccDynamicBannerSaga from 'yoda-site-components/lib/sagas/PlccDynamicBannerSaga';
import watchMissingPointsSaga from 'yoda-account-components/lib/sagas/MissingPointsSaga';
import watchMyListSaga from 'yoda-account-components/lib/sagas/MyListSaga';
import watchTokenSaga from 'yoda-account-components/lib/sagas/TokenSaga';
import watchSYFQuickScreenSaga from 'yoda-account-components/lib/sagas/SYFQuickScreenSaga';
import watchAccountDetailsSaga from './AccountDetailsSaga';
import watchAddressSaga from './AddressSaga';
import watchPaymentMethodsSaga from './PaymentMethodsSaga';
import watchRegistrySaga from './RegistrySaga';
import watchNotificationSaga from './NotificationSaga';
import watchAddressingConstSaga from './AddressingConstSaga';
import watchPromotionalSignUp from './PromotionalSignUpSaga';
import watchGroupSaga from './GroupSaga';

const siteComponentSagaList = Object.values(siteComponentSagas.injectedSagas);
const productSagas = [
    // watchLaunchNLearnSaga,
    /*
    GET_EMAILID_BY_TOKEN:
    node_modules/yoda-account-components/lib/components/CreateAccount/Page/CreateAccountWrapper.jsx
    node_modules/yoda-account-components/lib/components/Login/Page/SignInWrapper.jsx
    */
    watchGroupSaga,
    /*
    src/containers/Pages/CAMDashboard/CAMDashboard.jsx
    src/components/ProfileSettings/ProfileSettings.jsx
    src/components/MyInfoAddresses/MyInfoAddresses.jsx
    src/components/MyWallet/MyWalletPayment.jsx
    */
    watchAccountDetailsSaga,
    /*
    GET_ADDRESSES:
    src/sagas/AddressSaga.js
    src/sagas/PaymentMethodsSaga.js
    src/sagas/WalletBarcodeSaga.js
    POST_ADDRESSES:
    UPDATE_ADDRESSES:
    DELETE_ADDRESSES:
    DELETE_ADDRESSES_CREATE:
    DELETE_ADDRESSES_UPDATE:
    SET_DEFAULT_ADDRESS:
    src/components/MyInfoAddresses/MyInfoAddresses.jsx
    */
    watchAddressSaga,
    /*
    GET_PAYMENT_METHODS:
    src/sagas/AddressSaga.js
    src/sagas/PaymentMethodsSaga.js
    src/sagas/WalletBarcodeSaga.js
    UPDATE_PAYMENT_METHOD:
    ADD_PAYMENT_METHOD:
    DELETE_PAYMENT_METHOD:
    SET_DEFAULT_PAYMENT_METHOD:
    src/components/MyWallet/MyWalletPayment.jsx
    */
    watchPaymentMethodsSaga,
    /*
    GET_REFRESH_TOKEN_REQUEST_ACCOUNT:
    node_modules/yoda-site-components/lib/sagas/FactorySaga.js
    node_modules/yoda-account-components/lib/sagas/FactorySaga.js
    */
    watchTokenSaga,
    /*
    node_modules/yoda-account-components/lib/components/CreateAccount/Page/CreateAccountWrapper.jsx
    node_modules/yoda-account-components/lib/components/Login/Page/SignInWrapper.jsx
    node_modules/yoda-account-components/lib/components/SignInSlider/wrappers/LoginWrapper.jsx
    */
    watchRegistrySaga,
    /*
    GET_NOTIFICATION:
    UPDATE_NOTIFICATION:
    src/components/Notification/Notification.jsx
    src/components/Preferences/Preferences.jsx
    */
    watchNotificationSaga,
    /*
    src/components/MyInfoAddresses/MyInfoAddressAdd/MyInfoAddressAdd.jsx
    src/components/MyWallet/WalletAddCreditCard/WalletAddCreditCard.jsx
    */
    watchAddressingConstSaga,
    /*
    node_modules/yoda-account-components/lib/components/MissingPointsModal/MissingPoints/MissingPoints.jsx
    */
    watchMissingPointsSaga,
    /*
    node_modules/yoda-site-components/lib/components/CreateMyList/CreateMyList.jsx
    */
    watchMyListSaga,
    /*
    src/components/MyWallet/MyWalletPage.jsx
    */
    // watchNewWalletSaga,
    /*
    src/containers/Pages/PromoSMSEmail/PromoSMSEmailForm.jsx
    */
    watchPromotionalSignUp,
    watchSYFQuickScreenSaga,
    watchPlccDynamicBannerSaga,
    ...siteComponentSagaList,
];

const injectedSagas = {};
for (const saga of productSagas) { // eslint-disable-line
    // 1. Check that every saga has a name
    if (!saga.sagaName) {
        throw new Error(
            `Every saga has to have sagaName property. For debug purposes: ${saga.toString()}`
        );
    }

    // 2. Check that we have only unique sagas (one could be from components, another the same one from shared)
    if (injectedSagas[saga.sagaName]) {
        throw new Error(
            `That saga ${saga.sagaName} was already registered. Only 1 instance for particular name is allowed`
        );
    }
    injectedSagas[saga.sagaName] = saga;
}

const productRootSaga = function* productRootSaga() {
    yield all(Object.values(injectedSagas).map((saga) => fork(saga)));
};

productRootSaga.injectedSagas = injectedSagas;

export default productRootSaga;
